<template>
  <v-container class="container background-bg full-height" fluid>
    <v-row justify="center" class="mt-2">
      <v-col sm="12" md="12" lg="6">
        <v-card class="align-center pa-4">
          <v-row justify="center">
            <div>
              <img
                class="card-logo mt-2"
                src="../assets/enel_foundation_logo.png"
              />
            </div>
          </v-row>

          <v-row class="mt-8" justify="center">
            <header-title :title="headerTitle" />
          </v-row>

          <v-row class="mt-4" justify="space-around">
            <v-col sm="12" md="6" lg="5">
              <v-row>
                <v-text-field
                  @blur="$v.name.$touch"
                  :error-messages="nameRequiredErrors($v.name)"
                  v-model="name"
                  label="Full Name"
                ></v-text-field>
              </v-row>
              <v-row>
                <v-text-field
                  v-model="birthdate"
                  label="Date of Birth"
                  required
                  type="date"
                  @blur="$v.dateOfBirth.$touch"
                  :error-messages="fieldRequiredMessage($v.dateOfBirth)"
                ></v-text-field>
              </v-row>
              <v-row>
                <div class="d-flex">
                  <v-autocomplete
                    class="mr-4 width-30p"
                    v-model="countryCode"
                    :items="allCountries"
                    @blur="$v.countryCode.$touch"
                    item-text="dialCode"
                    item-value="dialCode"
                    @change="phoneChange"
                    :error-messages="fieldRequiredMessage($v.countryCode)"
                    label="Code"
                  ></v-autocomplete>
                  <v-text-field
                    required
                    v-model="phone"
                    label="Phone Number"
                    @blur="$v.phone.$touch"
                    @change="phoneChange"
                    :error-messages="fieldRequiredMessage($v.phone)"
                  ></v-text-field>
                </div>
              </v-row>
              <v-row>
                <v-autocomplete
                  v-model="countryOfOrigin"
                  :items="countries"
                  @blur="$v.countryOfOrigin.$touch"
                  :error-messages="fieldRequiredMessage($v.countryOfOrigin)"
                  label="Country of Origin"
                ></v-autocomplete>
              </v-row>
              <v-row justify="center">
                <v-autocomplete
                  v-model="countryOfResidence"
                  :items="countries"
                  label="Country of Residence"
                  @blur="$v.countryOfResidence.$touch"
                  :error-messages="fieldRequiredMessage($v.countryOfResidence)"
                ></v-autocomplete>
              </v-row>
            </v-col>
            <v-col sm="12" md="6" lg="4">
              <v-row>
                <v-select
                  v-model="gender"
                  label="Gender"
                  :items="genderItems"
                  :error-messages="fieldRequiredMessage($v.gender)"
                  item-value="value"
                  item-text="text"
                />
              </v-row>
              <v-row>
                <v-text-field
                  v-model="currentOccupation"
                  label="Current Occupation"
                  @blur="$v.currentOccupation.$touch"
                  :error-messages="fieldRequiredMessage($v.currentOccupation)"
                ></v-text-field>
              </v-row>
              <v-row v-if="!avatarSelected">
                <v-file-input
                  accept="image/*"
                  prepend-icon="mdi-camera"
                  id="avatar"
                  :error-messages="fieldRequiredMessage($v.selectedAvatarImage)"
                  label="Profile Picture"
                />
                <avatar-cropper
                  trigger="#avatar"
                  :labels="avatarCropper.labels"
                  :cropper-options="avatarCropper.options"
                  :output-mime="avatarCropper.mime"
                  :upload-handler="uploadAvatar"
                />
              </v-row>
              <v-row v-if="avatarSelected" class="mt-6">
                <div
                  style="position: relative"
                  class="d-flex align-center justify-space-between flex-wrap"
                >
                  <v-avatar size="150" class="mb-4">
                    <v-img :src="selectedAvatarImage" />
                  </v-avatar>
                  <v-btn
                    @click="removeAvatar"
                    small
                    text
                    class="text-capitalize ml-4"
                  >
                    <v-icon small>mdi-close</v-icon>
                    <span class="ml-2">Remove photo</span>
                  </v-btn>
                </div>
              </v-row>
            </v-col>
          </v-row>

          <v-row class="my-6">
            <div
              class="d-flex full-width justify-space-between align-center px-16 mt-10"
            >
              <div class="text-caption">
                * the information fields in this page are all mandatory
              </div>
              <div class="d-flex   justify-end align-end">
                <v-btn
                  @click="$router.go(-1)"
                  text
                  color="primary"
                  v-if="profileExists"
                  class="mr-6"
                  >Cancel</v-btn
                >
                <v-btn
                  :loading="loading"
                  @click="saveProfile"
                  color="primary"
                  class="px-10"
                  >{{ this.nextButtonTitle }}</v-btn
                >
              </div>
            </div>
          </v-row>

          <v-row justify="center" v-if="showError" wrap>
            <v-alert type="error" class="caption pa-1 mt-4">{{
              errorMessage
            }}</v-alert>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import HeaderTitle from "../components/HeaderTitle";
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
import { countries } from "../services/countries.service";
import allCountries from "../services/allCountries.service";
import AvatarCropper from "vue-avatar-cropper";
import moment from "moment";

import { required } from "vuelidate/lib/validators";
import clonedeep from "lodash.clonedeep";
import isEqual from "lodash.isequal";
import pick from "lodash.pick";

const fullNameRequired = (value) => {
  const length = value.split(" ").length;
  return length > 1;
};

export default {
  name: "CreateProfile",
  components: {
    HeaderTitle,
    AvatarCropper
  },
  created() {
    if (!this.profileExists) {
    } else {
      this.countryCode = this.phoneNumber.substring(1, 4);
      this.phone = this.phoneNumber.substring(4);
      this.selectedAvatarImage = this.photo.url;
      // if we're in edit profile mode
      // we need to check if the user modified the form
      // for that we need to clone deep the current profile
      this.originalProfile = clonedeep(this.profile);
    }
  },
  data() {
    return {
      originalProfile: null,
      showDatePicker: false,
      selectedAvatarImage: null,
      avatarBlob: null,
      profilePictureUploaded: false,
      loading: false,
      errorMessage: "",
      countries,
      birthDate: "",
      allCountries,
      profilePicture: "",
      countryCode: "",
      phone: "",
      minDate: moment()
        .subtract(4, "years")
        .toISOString(),
      maxDate: moment()
        .subtract(4, "years")
        .toISOString(),
      avatarCropper: {
        labels: {
          submit: "Done",
          cancel: "Cancel"
        },
        options: {
          aspectRatio: 1
        },
        mime: "image/jpeg"
      },
      genderItems: [
        {
          text: "Male",
          value: "MALE"
        },
        {
          text: "Female",
          value: "FEMALE"
        }
      ]
    };
  },
  validations: {
    name: {
      required,
      fullNameRequired
    },
    gender: {
      required
    },
    dateOfBirth: {
      required
    },
    countryCode: {
      required
    },
    phone: {
      required
    },
    countryOfOrigin: {
      required
    },
    countryOfResidence: {
      required
    },
    currentOccupation: {
      required
    },
    selectedAvatarImage: {
      required
    }
  },
  computed: {
    ...mapFields("profile", [
      "profile",
      "newProfile",
      "profile.name",
      "profile.currentOccupation",
      "profile.countryOfResidence",
      "profile.countryOfOrigin",
      "profile.dateOfBirth",
      "profile.phoneNumber",
      "profile.photoFileId",
      "profile.gender",
      "profile.photo"
    ]),
    profileExists() {
      return this.profile._id && this.profile._id.length;
    },
    headerTitle() {
      return this.profileExists ? "Update Your Profile" : "Create Your Profile";
    },
    avatarSelected() {
      return this.selectedAvatarImage ? true : false;
    },
    showError() {
      return this.errorMessage && this.errorMessage.length;
    },
    nextButtonTitle() {
      return this.profileExists ? "Save" : "Next";
    },
    birthdate: {
      get() {
        return moment(this.dateOfBirth).format("YYYY-MM-DD");
      },
      set(value) {
        this.dateOfBirth = value;
      }
    },
    profileFields() {
      const fields = pick(this.profile, [
        "_id",
        "name",
        "gender",
        "currentOccupation",
        "countryOfResidence",
        "countryOfOrigin",
        "dateOfBirth",
        "phoneNumber",
        "photoFileId"
      ]);

      if (!this.profileExists) {
        delete fields._id;
      }

      return fields;
    }
  },
  methods: {
    ...mapActions("toast", { showSuccessMessage: "showSuccessMessage" }),
    ...mapActions("profile", {
      createUserProfile: "createProfile",
      updateUserProfile: "updateProfile",
      uploadProfilePicture: "uploadProfilePicture",
      setProfile: "setProfile"
    }),

    phoneChange() {
      this.phoneNumber = `+${this.countryCode}${this.phone}`;
      // console.log("phone is " + this.phoneNumber);
    },
    fieldRequiredMessage(field) {
      const errors = [];
      if (!field.$dirty) {
        return errors;
      }
      !field.required && errors.push("Field is required");
      return errors;
    },
    nameRequiredErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) {
        return errors;
      }
      !this.$v.name.required && errors.push("Field is required");
      !this.$v.name.fullNameRequired &&
        errors.push("Please enter your Full Name");
      return errors;
    },
    uploadAvatar(file) {
      file.getCroppedCanvas().toBlob((blob) => {
        this.avatarBlob = blob;
      });

      this.selectedAvatarImage = file
        .getCroppedCanvas()
        .toDataURL(this.avatarCropper.mime);
    },
    removeAvatar() {
      this.selectedAvatarImage = null;
      this.profilePictureUploaded = false;
    },
    async saveProfile() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      if (!this.profileExists) {
        this.createProfile();
      } else {
        this.updateProfile();
      }
    },

    async updateProfile() {
      // if profile has not been changed we can simply return to previous screen
      // we check for avatarBlob because the user may modify his profile picture
      if (isEqual(this.profile, this.originalProfile) && !this.avatarBlob) {
        this.$router.go(-1);
        return;
      }

      this.loading = true;

      try {
        // handle profile picture upload
        if (this.avatarBlob) {
          const photo = await this.uploadProfilePicture(this.avatarBlob);
          this.photoFileId = photo[0]._id;
        }

        const profile = await this.updateUserProfile(this.profileFields);
        this.setProfile(profile);
        this.showSuccessMessage("Profile has been saved");
        this.$router.go(-1);
      } finally {
        this.loading = false;
      }
    },

    async createProfile() {
      this.loading = true;

      try {
        if (!this.profilePictureUploaded) {
          const photo = await this.uploadProfilePicture(this.avatarBlob);
          this.profilePictureUploaded = true;

          // save the photo id in the user profile
          this.photoFileId = photo[0]._id;
        }

        // create the user profile
        const profile = await this.createUserProfile(this.profileFields);

        this.setProfile(profile);

        // route user to the next screen
        this.$router.replace({
          name: "home"
        });
      } catch (error) {
        this.errorMessage = error.message;
        setTimeout(() => {
          this.errorMessage = "";
        }, 2000);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
